export const dashPathFor = (user) => (!user ? "/login" : user.profile_complete === false ? "/onboarding" : user.role === "admin" ? "/admin" : user.role === "institute" ? "/institute" : user.role === "teacher" ? "/teacher" : "/student");
